import {Field} from 'formik';

import {
    FormikRadioGroup,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from "@mantine/core";


export const FormComponent = () => {

    return (
        <Stack gap='lg'>
            <PlatformFieldset legend={'Customer'}>
                <Field
                    name='name'
                    label='Name'
                    description='Please enter the customer name'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='Please enter customer description'
                    component={FormikTextarea}
                    my={'xl'}
                />

            </PlatformFieldset>


            <PlatformFieldset legend={'Contact Info'}>
                <Field
                    name='contactInfo.email'
                    label='Email'
                    description='Please enter customer email'
                    component={FormikTextInput}
                    type='email'
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='contactInfo.phone'
                    label='Phone'
                    description='Please enter customer phone'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='contactInfo.website'
                    label='Website'
                    description='Please enter customer website'
                    component={FormikTextInput}
                    type='url'
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Metadata'}>

                <Field
                    name='status'
                    label='Status'
                    description='Please enter customer status'
                    component={FormikRadioGroup}
                    data={[
                        { label: 'Prospect', value: 'PROSPECT' },
                        { label: 'Trial', value: 'TRIAL' },
                        { label: 'Trial Expired', value: 'TRIAL_EXPIRED' },
                        { label: 'Active', value: 'ACTIVE' },
                        { label: 'Active Grace', value: 'ACTIVE_GRACE' },
                        { label: 'Past Due', value: 'PAST_DUE' },
                        { label: 'Suspended', value: 'SUSPENDED' },
                        { label: 'Paused', value: 'PAUSED' },
                        { label: 'Downgraded', value: 'DOWNGRADED' },
                        { label: 'Cancelled', value: 'CANCELLED' },
                        { label: 'Inactive', value: 'INACTIVE' },
                        { label: 'Blocked', value: 'BLOCKED' },
                        { label: 'Archived', value: 'ARCHIVED' }
                    ]}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>

        </Stack>
    );
};
